import SearchBoxPrimitive from "./SearchBoxPrimitive";
import FindInVizDropdownItem from "./FindInVizDropdownItem";
import { memo } from "react";

interface FindInVizDropdownProps {
  findInVizOptions: Array<{ id: string; label: string; productId?: string }>;
  highlightedItem: string | undefined;
  setHighlightedItem: (id: string | undefined) => void;
  setHovered: (hovered: boolean) => void;
  setOpen: (open: boolean) => void;
  /** Placeholder text for the search input */
  placeholderText?: string;
}

const FindInVizDropdown = ({
  findInVizOptions,
  highlightedItem,
  setHighlightedItem,
  setHovered,
  setOpen,
  placeholderText = "Find in graph",
}: FindInVizDropdownProps) => {
  const onChangeEvent = ({ id }: { id: string | undefined }) => {
    setHighlightedItem(id);
    if (id === undefined) {
      setHighlightedItem(undefined);
      setHovered(false);
      setOpen(false);
    }
  };

  const matchSelectedItem = highlightedItem
    ? findInVizOptions.find(
        (option: any) =>
          option.id === highlightedItem ||
          option.productId === highlightedItem,
      )
    : undefined;

  return (
    <SearchBoxPrimitive
      items={findInVizOptions}
      hashFunction={(item: any) => item.label}
      placeholder={placeholderText}
      ItemRenderComponent={FindInVizDropdownItem}
      onChangeEvent={onChangeEvent}
      selectedValue={matchSelectedItem}
    />
  );
};

export default memo(FindInVizDropdown);
